// extracted by mini-css-extract-plugin
module.exports = {"tagsFieldOption":"TagsField_tagsFieldOption__1_L1M","color":"TagsField_color__38kfS"};